import { render, staticRenderFns } from "./advanced-text-visualizer.vue?vue&type=template&id=21b350fa&scoped=true&"
import script from "./advanced-text-visualizer.vue?vue&type=script&lang=js&"
export * from "./advanced-text-visualizer.vue?vue&type=script&lang=js&"
import style0 from "./advanced-text-visualizer.vue?vue&type=style&index=0&id=21b350fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b350fa",
  null
  
)

export default component.exports